// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf } from "@altostra/type-validations";
import { nullOrUndefined, string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsCurrentsIntegrationsConfigResult = objectOf({
  eventbridge: objectOf({
    allowed_regions: arrayOf(
      objectOf({
        region: string,
        label: string,
      })
    ),
  }),
  azure_blob: objectOf({
    workload_identity_issuer_url: anyOf(nullOrUndefined, string),
    workload_identity_subject: string,
    workload_identity_audience: string,
  }),
});
